/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Information about the dynamic bonding curve if one exists for the coin
 * @export
 * @interface DynamicBondingCurveInsights
 */
export interface DynamicBondingCurveInsights {
    /**
     * Address of the bonding curve pool
     * @type {string}
     * @memberof DynamicBondingCurveInsights
     */
    address?: string;
    /**
     * Current price in the pool's quote token (e.g., AUDIO)
     * @type {number}
     * @memberof DynamicBondingCurveInsights
     */
    price?: number;
    /**
     * Current price in USD
     * @type {number}
     * @memberof DynamicBondingCurveInsights
     */
    priceUSD?: number;
    /**
     * Progress along the bonding curve (0.0 - 1.0)
     * @type {number}
     * @memberof DynamicBondingCurveInsights
     */
    curveProgress?: number;
    /**
     * Whether the bonding curve has been migrated
     * @type {boolean}
     * @memberof DynamicBondingCurveInsights
     */
    isMigrated?: boolean;
    /**
     * Creator quote fee for the bonding curve
     * @type {number}
     * @memberof DynamicBondingCurveInsights
     */
    creatorQuoteFee?: number;
    /**
     * Total trading quote fee accumulated
     * @type {number}
     * @memberof DynamicBondingCurveInsights
     */
    totalTradingQuoteFee?: number;
    /**
     * Address of the pool creator's wallet
     * @type {string}
     * @memberof DynamicBondingCurveInsights
     */
    creatorWalletAddress?: string;
}

/**
 * Check if a given object implements the DynamicBondingCurveInsights interface.
 */
export function instanceOfDynamicBondingCurveInsights(value: object): value is DynamicBondingCurveInsights {
    let isInstance = true;

    return isInstance;
}

export function DynamicBondingCurveInsightsFromJSON(json: any): DynamicBondingCurveInsights {
    return DynamicBondingCurveInsightsFromJSONTyped(json, false);
}

export function DynamicBondingCurveInsightsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DynamicBondingCurveInsights {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'address': !exists(json, 'address') ? undefined : json['address'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'priceUSD': !exists(json, 'priceUSD') ? undefined : json['priceUSD'],
        'curveProgress': !exists(json, 'curveProgress') ? undefined : json['curveProgress'],
        'isMigrated': !exists(json, 'isMigrated') ? undefined : json['isMigrated'],
        'creatorQuoteFee': !exists(json, 'creatorQuoteFee') ? undefined : json['creatorQuoteFee'],
        'totalTradingQuoteFee': !exists(json, 'totalTradingQuoteFee') ? undefined : json['totalTradingQuoteFee'],
        'creatorWalletAddress': !exists(json, 'creatorWalletAddress') ? undefined : json['creatorWalletAddress'],
    };
}

export function DynamicBondingCurveInsightsToJSON(value?: DynamicBondingCurveInsights | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'address': value.address,
        'price': value.price,
        'priceUSD': value.priceUSD,
        'curveProgress': value.curveProgress,
        'isMigrated': value.isMigrated,
        'creatorQuoteFee': value.creatorQuoteFee,
        'totalTradingQuoteFee': value.totalTradingQuoteFee,
        'creatorWalletAddress': value.creatorWalletAddress,
    };
}

